import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

function ResponsiveAppBar() {
  const navigate = useNavigate();
  const { t } = useTranslation("global");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Limpiar cookies y localStorage
    Cookies.remove('sessionId');
    localStorage.clear();

    // Redirigir al login
    navigate('/proveedores/Cerrar');
    handleClose();
  };

  // Obtener información del usuario
  const userName = localStorage.getItem('Tproveedor') || 'Usuario';
  const userEmail = localStorage.getItem('Email') || '';

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'white',
        borderBottom: '1px solid #E0E0E0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ py: 1.5 }}>
          {/* Logo Izquierda */}
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <img
              src="https://talsa.com.co/cdn/shop/files/Talsa-Logo.png?v=1758921849"
              alt="Talsa Logo"
              style={{ height: '50px', objectFit: 'contain' }}
            />

            {/* User Name Display */}
            {userName && (
              <Box sx={{
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                ml: 2,
                pl: 2,
                borderLeft: '2px solid #E0E0E0',
                justifyContent: 'center'
              }}>
                <Typography variant="body1" sx={{ fontWeight: 700, color: '#2D3436', lineHeight: 1 }}>
                  {userName}
                </Typography>
              </Box>
            )}
          </Box>

          {/* Tagline Centro */}
          <Typography
            variant="h6"
            sx={{
              color: '#BD1F34',
              fontWeight: 600,
              fontSize: { xs: '0.9rem', md: '1.25rem' },
              display: { xs: 'none', sm: 'block' }
            }}
          >
            {t('appbar.portal')}
          </Typography>

          {/* User Menu Derecha */}
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <Avatar
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor: '#BD1F34',
                  fontWeight: 600
                }}
              >
                {userName.charAt(0).toUpperCase()}
              </Avatar>
            </IconButton>
          </Box>

          {/* Dropdown Menu */}
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 3,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.15))',
                mt: 1.5,
                minWidth: 220,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {/* User Info */}
            <Box sx={{ px: 2, py: 1.5 }}>
              <Typography variant="body1" sx={{ fontWeight: 600, color: '#1F2937' }}>
                {userName}
              </Typography>
              {userEmail && (
                <Typography variant="caption" sx={{ color: '#6B7280' }}>
                  {userEmail}
                </Typography>
              )}
            </Box>

            <Divider />

            {/* Logout Option */}
            <MenuItem onClick={handleLogout} sx={{ py: 1.5 }}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" sx={{ color: '#BD1F34' }} />
              </ListItemIcon>
              <Typography sx={{ color: '#374151' }}>{t('appbar.logout')}</Typography>
            </MenuItem>
          </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;
